"use strict"

import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import { Button } from "react-bootstrap"
import PropTypes from "prop-types"

import ProcurementTable from "./ProcurementTable"
import ModalCreateProcurementItem from "./modals/ModalCreateProcurementItem"
import ModalUploadProcurementItems from "./modals/ModalUploadProcurementItems"
import { withInventoryConfig } from "../../../config/InventoryConfigProvider"

function Procurement({ user_permissions = [], getProcurementItems, onItemReceived }) {
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [showUploadModal, setShowUploadModal] = useState(false)

  return (
    <div>
      <div className={"row"}>
        <div className={"col-sm-4"}>
          <h4 style={{ margin: "5px 0px" }}>
            <span className={"fa fa-shopping-cart"} />
            &nbsp;&nbsp;
            <FormattedMessage id={"inventory.procure-items"} />
          </h4>
        </div>
        <div className={"col-sm-8"} align={"right"}>
          <Button variant={"outline-primary"} onClick={getProcurementItems}>
            <span className={"fa fa-refresh"} />
            &nbsp;
            <FormattedMessage id={"general.refresh"} />
          </Button>
          &nbsp;&nbsp;
          <Button
            variant={"primary"}
            disabled={!user_permissions.includes("add_inventoryitem")}
            onClick={() => setShowCreateModal(true)}
          >
            <span className={"fa fa-plus text_white"} />
            &nbsp;
            <FormattedMessage id={"inventory.add-new-item"} />
          </Button>
          &nbsp;&nbsp;
          <Button
            variant={"primary"}
            disabled={!user_permissions.includes("add_inventoryitem")}
            onClick={() => setShowUploadModal(true)}
          >
            <span className={"fa fa-arrow-circle-o-up text_white"} />
            &nbsp;
            <FormattedMessage id={"general.upload.csv"} />
          </Button>
        </div>
      </div>
      <hr style={{ margin: "15px 0px 25px 0px" }} />
      <ProcurementTable onItemReceived={onItemReceived} />

      {/*----- Modals -----*/}
      {user_permissions.includes("add_inventoryitem") && (
        <>
          {showCreateModal && (
            <ModalCreateProcurementItem
              show={showCreateModal}
              onHide={() => setShowCreateModal(false)}
              onSuccess={() => {
                setShowCreateModal(false)
                getProcurementItems()
              }}
            />
          )}

          {showUploadModal && (
            <ModalUploadProcurementItems
              show={showUploadModal}
              onHide={() => setShowUploadModal(false)}
              onSuccess={() => {
                setShowUploadModal(false)
                getProcurementItems()
              }}
            />
          )}
        </>
      )}
    </div>
  )
}

export default withInventoryConfig(Procurement)

Procurement.propTypes = {
  onItemReceived: PropTypes.func,
  getProcurementItems: PropTypes.func,
  user_permissions: PropTypes.array,
}
